import { Add, Remove } from '@mui/icons-material';
import PropTypes from 'prop-types';
import React from 'react';

type InputNumberProps = {
  value: number
  minValue?: number,
  maxValue?: number,
  onMinus: () => void,
  onPlus: () => void
};

const InputNumber: React.FC<InputNumberProps> = ({ value, minValue, maxValue, onMinus, onPlus }) => {
  return <div className="tw-flex">
    <button type="button" disabled={value === minValue} className="tw-outline-none focus:tw-outline-none tw-flex tw-items-center tw-justify-center disabled:tw-text-gray-200 disabled:tw-border-gray-200 tw-border tw-rounded-full tw-border-primary-500 tw-font-bold tw-w-10 tw-h-10 tw-transition-colors tw-duration-200 tw-ease-in-out" onClick={onMinus}>
      <Remove fontSize="small" />
    </button>
    <input type="text" value={value} className="tw-w-10 tw-h-10 tw-text-center tw-outline-none tw-font-semibold" readOnly></input>
    <button type="button" disabled={value === maxValue} className="tw-outline-none focus:tw-outline-none tw-flex tw-items-center tw-justify-center disabled:tw-text-gray-200 disabled:tw-border-gray-200 tw-border tw-rounded-full tw-border-primary-500 tw-font-bold tw-w-10 tw-h-10 tw-transition-colors tw-duration-200 tw-ease-in-out" onClick={onPlus}>
      <Add fontSize="small" />
    </button>
  </div>;
};

InputNumber.propTypes = {
  value: PropTypes.number.isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  onMinus: PropTypes.func.isRequired,
  onPlus: PropTypes.func.isRequired
};

export default InputNumber;
